import React from 'react'
import * as pathname from './pathname'
import { MODULES, GROUPS, METHOD } from '../../utils/constants/roles'
import Centers from '../../views/centers/main/Centers.tsx'
import CenterData from '../../views/centers/main/CenterData.tsx'
import CenterComercialData from '../../views/centers/main/CenterComercialData.tsx'
import CenterContracts from '../../views/centers/main/CenterContracts.tsx'
import CenterConventions from '../../views/centers/main/CenterConventions.tsx'
import CenterServices from '../../views/centers/main/CenterServices.tsx'
import CenterManuals from '../../views/centers/main/CenterManuals.tsx'
import CenterWorkers from '../../views/centers/main/CenterWorkers.tsx'
import CenterTechnics from '../../views/centers/main/CenterTechnics.tsx'
import CenterMaintenances from '../../views/centers/main/CenterMaintances.tsx'
import CenterCashRegisters from '../../views/centers/main/CenterCashRegisters.tsx'
import CenterCashRegistersEdit from '../../views/centers/main/edit/CenterCashRegistersEdit.tsx'

const centersRoutes = [
  // {
  //     path: pathname.centersPathname.CENTERS,
  //     name: 'centers',
  //     element: <Centers />,
  //     role: { module: MODULES.CENTERS, group: GROUPS.CENTERS, method: METHOD.GET }
  // },
  {
    // path: pathname.ownCentersPathname.OWN,
    path: pathname.mainCentersPathname.OWNER,
    name: 'centersOwn',
    element: <Centers centerType="OWNER" />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    // path: pathname.franchiseCentersPathname.FRANCHISE,
    path: pathname.mainCentersPathname.FRANCHISE,
    name: 'centersFranchise',
    element: <Centers centerType="FRANCHISE" />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    // path: pathname.otherCentersPathname.OTHER,
    path: pathname.mainCentersPathname.OTHER,
    name: 'centersOther',
    element: <Centers centerType="OTHER" />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },

  {
    path: pathname.mainCentersPathname.DATA(':id'),
    name: 'center',
    element: <CenterData />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.mainCentersPathname.COMERCIAL_DATA_ALL(':id'),
    name: 'comercialData',
    element: <CenterComercialData />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.mainCentersPathname.WORKERS(':id'),
    name: 'workers',
    element: <CenterWorkers />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.mainCentersPathname.CONTRACTS(':id'),
    name: 'contracts',
    element: <CenterContracts />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.mainCentersPathname.CONVENTIONS(':id'),
    name: 'conventions',
    element: <CenterConventions />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.mainCentersPathname.SERVICES(':id'),
    name: 'services',
    element: <CenterServices />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.mainCentersPathname.TECHNICS(':id'),
    name: 'technics',
    element: <CenterTechnics />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.mainCentersPathname.MAINTENANCES(':id'),
    name: 'maintenances',
    element: <CenterMaintenances />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },

  {
    path: pathname.mainCentersPathname.CASH_REGISTERS(':id'),
    name: 'cashRegisters',
    element: <CenterCashRegisters />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.mainCentersPathname.CASH_REGISTERS_EDIT(':id'),
    name: 'cashRegisters',
    element: <CenterCashRegistersEdit />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  // {
  //     path: pathname.mainCentersPathname.CASHREGISTERS_EDIT(':id'),
  //     name: 'cashRegisters',
  //     element: <CenterCashRegistersEdit />,
  //     role: { module: MODULES.CENTERS, group: GROUPS.CENTERS, method: METHOD.GET }
  // },

  {
    path: pathname.mainCentersPathname.MANUALS(':id'),
    name: 'manuals',
    element: <CenterManuals />,
    role: {
      module: MODULES.CENTERS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
]

export default centersRoutes
